<template>
  <div>
    <ais-instant-search
      :search-client="searchClient"
      index-name="restaurant"
      id="algolia-instant-search-demo"
    >
      <ais-configure :hits-per-page.camel="9" :filters="filters" />

      <div class="algolia-header mb-4">
        <div class="flex md:items-end items-center justify-between flex-wrap">
          <vs-button
                class="w-full mb-5 cursor-pointer xl:hidden"
                @click="setLang"
              >中文/English</vs-button>
          <vs-button
            class="w-full mb-5 cursor-pointer xl:hidden"
            @click.stop="showSidebar"
          >{{$store.state.getLabel($store.state.language).menu}}</vs-button>
          <vs-button
            class="w-full mb-5 cursor-pointer xl:hidden"
            @click.stop="toggleFilterSidebar"
          >{{$store.state.getLabel($store.state.language).res_type}}</vs-button>

          <p
            class="lg:inline-flex hidden font-semibold algolia-filters-label"
          >{{$store.state.getLabel($store.state.language).menu}}</p>

          <div class="flex justify-between items-end flex-grow">
            <!-- Stats -->
            <ais-stats>
              <p
                slot-scope="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }"
                class="font-semibold md:block hidden"
                v-if="nbHits>0"
              >{{$store.state.getLabel($store.state.language).found_1}} {{ nbHits }} {{$store.state.getLabel($store.state.language).found_2}} ({{ processingTimeMS }}ms)</p>
              <p
                class="font-semibold md:block hidden text-primary"
                v-else
              >{{$store.state.getLabel($store.state.language).no_resMsg}}</p>
            </ais-stats>

            <div class="flex flex-wrap">
              <!-- ITEM VIEW - GRID/LIST -->
              <div>
                <feather-icon
                  icon="GridIcon"
                  @click="currentItemView='item-grid-view'"
                  class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer hidden"
                  :svgClasses="{'text-primary stroke-current': currentItemView == 'item-grid-view'}"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="algolia-content-container" class="relative clearfix">
        <vs-sidebar
          class="items-no-padding vs-sidebar-rounded background-absolute"
          parent="#algolia-content-container"
          :click-not-close="clickNotClose"
          :hidden-background="clickNotClose"
          v-model="isFilterSidebarActive"
        >
          <div class="p-4 filter-container">
            <!-- CATEGORIES -->
            <h6
              class="font-bold px-6 py-3"
            >{{$store.state.getLabel($store.state.language).res_dish}}</h6>
            <ais-hierarchical-menu :attributes="algoliaCategories" :limit="20">
              <div slot-scope="{ items, refine }">
                <ul>
                  <li
                    v-for="item in items"
                    :key="item.value"
                    class="flex items-center cursor-pointer py-1 px-3"
                    @click="refine(item.value); chooseCat();"
                  >
                    <span
                      class="ml-2 text-lg ml-3"
                      :class="{'text-primary': item.isRefined}"
                    >{{ item.label }}</span>
                  </li>
                </ul>
              </div>
            </ais-hierarchical-menu>
          </div>
        </vs-sidebar>
        <!-- RIGHT COL -->
        <div :class="{'sidebar-spacer-with-margin': clickNotClose}">
          <!-- SEARCH BAR -->
          <ais-search-box>
            <div slot-scope="{ currentRefinement, isSearchStalled, refine }">
              <div class="relative mb-8">
                <!-- SEARCH INPUT -->
                <vs-input
                  class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
                  :placeholder="$store.state.getLabel($store.state.language).find_rest"
                  v-model="currentRefinement"
                  @input="refine($event)"
                  @keyup.esc="refine('')"
                  size="large"
                />

                <!-- SEARCH LOADING -->
                <p :hidden="!isSearchStalled" class="mt-4 text-grey">
                  <feather-icon icon="ClockIcon" svgClasses="w-4 h-4" class="mr-2 align-middle" />
                  <span>Loading...</span>
                </p>

                <!-- SEARCH ICON -->
                <div
                  slot="submit-icon"
                  class="absolute top-0 right-0 py-4 px-6"
                  v-show="!currentRefinement"
                >
                  <feather-icon icon="SearchIcon" svgClasses="h-6 w-6" />
                </div>

                <!-- CLEAR INPUT ICON -->
                <div
                  slot="reset-icon"
                  class="absolute top-0 right-0 py-4 px-6"
                  v-show="currentRefinement"
                >
                  <feather-icon
                    icon="XIcon"
                    svgClasses="h-6 w-6 cursor-pointer"
                    @click="refine('')"
                  />
                </div>
              </div>
            </div>
          </ais-search-box>

          <!-- SEARCH RESULT -->
          <ais-hits>
            <div slot-scope="{ items }">
              <!-- GRID VIEW -->
               <!-- {{items}} -->
              <template v-if="currentItemView == 'item-grid-view'">
                <div class="items-grid-view vx-row match-height">
                  <div
                    class="vx-col lg:w-1/3 sm:w-1/2 w-full"
                    v-for="item in items"
                    :key="item.objectID"
                  >
                    <item-grid-view :item="item">
                      <!-- SLOT: ACTION BUTTONS -->
                      <template slot="action-buttons">
                        <div class="flex flex-wrap">
                          <div
                            class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer"
                            @click="cartButtonClicked(item)"
                          >
                            <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                            <span
                              class="text-sm font-semibold ml-2"
                            >{{$store.state.getLabel($store.state.language).select}}</span>
                          </div>
                        </div>
                      </template>
                    </item-grid-view>
                  </div>
                </div>
              </template>
              <ais-stats>
                <p
                  slot-scope="{ hitsPerPage, nbPages, nbHits }"
                  class="font-semibold md:block xl:hidden text-primary text-center"
                  v-if="nbHits > 0"
                ></p>
                <p
                  class="font-semibold md:block xl:hidden text-primary text-center"
                  v-else
                >{{$store.state.getLabel($store.state.language).no_resMsg}}</p>
              </ais-stats>
              <vs-divider>End</vs-divider>
            </div>
          </ais-hits>

          <!-- PAGINATION -->
          <ais-pagination>
            <div
              slot-scope="{
                                currentRefinement,
                                nbPages,
                                pages,
                                isFirstPage,
                                isLastPage,
                                refine,
                                createURL
                            }"
            >
              <vs-pagination
                v-if="nbPages"
                :total="nbPages"
                :max="7"
                :value="currentRefinement + 1"
                @input="(val) => { refine(val - 1); scrollToTop();}"
              />
            </div>
          </ais-pagination>
        </div>
      </div>
    </ais-instant-search>
  </div>
</template>


<script>
import {
  AisClearRefinements,
  AisConfigure,
  AisHierarchicalMenu,
  AisHits,
  AisInstantSearch,
  AisNumericMenu,
  AisPagination,
  AisRangeInput,
  AisRatingMenu,
  AisRefinementList,
  AisSearchBox,
  AisSortBy,
  AisStats
} from "vue-instantsearch";
import firebase from "firebase/app";
import algoliasearch from "algoliasearch/lite";
//import firebase from "firebase/app";

export default {
  components: {
    ItemGridView: () => import("../components/ItemGridViewRestaurant.vue"),
    ItemListView: () => import("../components/ItemListViewRestaurant.vue"),
    AisClearRefinements,
    AisConfigure,
    AisHierarchicalMenu,
    AisHits,
    AisInstantSearch,
    AisNumericMenu,
    AisPagination,
    AisRangeInput,
    AisRatingMenu,
    AisRefinementList,
    AisSearchBox,
    AisSortBy,
    AisStats
  },
  data() {
    return {
      searchClient: algoliasearch(
        "XLH3X2N57P",
        "846de38e6e5f4cb5676e380501b7836f"
      ),
      // Filter Sidebar
      isFilterSidebarActive: true,
      askForLanguage: true,
      clickNotClose: true,
      currentItemView: "item-grid-view"
    };
  },
  computed: {
    algoliaCategories() {
      return ["type"];
    },
    toValue() {
      return (value, range) => [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max
      ];
    },
    baseUrl() {
      const path = this.$route.path;
      return path.slice(0, path.lastIndexOf("/"));
    },
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    todoFilter() {
      return this.$route.params.filter;
    },
    // GRID VIEW
    isInCart() {
      return itemId => this.$store.getters["isInSelectedRestaurant"](itemId);
    },
    isInWishList() {
      return itemId => this.$store.getters["isInWishRestaurantList"](itemId);
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    filters() {
      var str = "";
      //Time
      var timeNow = firebase.firestore.Timestamp.now()
        .toDate()
        .getHours();
      var timeNowMin = firebase.firestore.Timestamp.now()
        .toDate()
        .getMinutes();
      var day = firebase.firestore.Timestamp.now().toDate().getDay();
      
      if (timeNowMin < 10) timeNowMin = "0" + timeNowMin;
      var time = timeNow + "" + timeNowMin;
      //time = 1300;
      if (day == 0){
        var day = 7;
        str = str + " ( open <= " + time + " AND close >= " + time + ") AND open_"+day+"=1";
      }else{
        str = str + " ( open <= " + time + " AND close >= " + time + ") AND open_"+day+"=1";
      }
      
      return str;
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth();
    }
  },
  methods: {
    setLang() {
      this.askForLanguage = !this.askForLanguage;
      if(this.askForLanguage){
        this.$store.state.language = 'en';
      }else if (!this.askForLanguage){
        this.$store.state.language = 'zh';
      }
      
    },
    chooseCat() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = !this.isFilterSidebarActive;
      }
      this.$vs.notify({
        title: "提示",
        text: this.$store.state.getLabel(this.$store.state.language).updated,
        color: "success",
        iconPack: "feather",
        icon: "icon-alert-circle"
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    showSidebar() {
      this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false;
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true;
      }
    },
    // GRID VIEW - ACTIONS
    toggleFilterSidebar() {
      if (this.clickNotClose) return;
      this.isFilterSidebarActive = !this.isFilterSidebarActive;
    },
    toggleItemInWishList(item) {
      this.$store.dispatch("toggleRestInWishList", item);
    },
    additemInCart(item) {
      this.$store.dispatch("addRestInList", item);
    },
    removeItemFromRestList() {
      this.$store.dispatch("removeAllRestList");
    },
    getAvailable() {
      var timeNow = firebase.firestore.Timestamp.now()
        .toDate()
        .getHours();
      var timeNowMin = firebase.firestore.Timestamp.now()
        .toDate()
        .getMinutes();
      if (timeNowMin < 10) timeNowMin = "0" + timeNowMin;
      var time = timeNow + "" + timeNowMin;
      if (time < 1100 || time > 2200) return false;
      else return false;
    },
    cartButtonClicked(item) {
      if (this.isInCart(item.objectID))
        this.$router.push("/meal").catch(() => {});
      else {
        if (this.$store.state.selectedRestaurant.length == 0) {
          this.additemInCart(item);
          this.$router.push("/meal").catch(() => {});
        } else
          this.$vs.notify({
            title: "提示",
            text: "只能選擇一間餐廳!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning"
          });
      }
    }
  },
  created() {
    this.setSidebarWidth();
    this.removeItemFromRestList();
  },
  mounted() {
    if (!this.getAvailable()) this.$router.push("/service").catch(() => {});
  }
};
</script>


<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {
    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: 0.5rem;
    }

    .vs-sidebar--items {
      border-radius: 0.5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}
</style>

